// packages/shared-hooks/src/clients/useClient.ts
//
// `GET /clients/:id` — full aggregate (contacts + legal entities, both
// active and archived). The detail page filters archived rows client-side
// so a single fetch covers the live + archive sub-sections.
import { useQuery } from '@tanstack/react-query';
import { ClientDetailSchema, type ClientDetail } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { clientsKeys } from './keys.js';

export function useClient(id: string | null, options: { enabled?: boolean } = {}) {
  const client = useApiClient();
  return useQuery<ClientDetail>({
    queryKey: id ? clientsKeys.detail(id) : ['clients', 'detail', '__none__'],
    queryFn: ({ signal }) => {
      if (!id) throw new Error('useClient called without id');
      return client.get<ClientDetail>(`/clients/${id}`, { signal }, ClientDetailSchema);
    },
    enabled: (options.enabled ?? true) && id !== null,
  });
}
